import './Stats.css';

const STATS = [
  { value: '8', label: 'Core Service Areas' },
  { value: '6+', label: 'Global Regulatory Agencies' },
  { value: '100%', label: 'Compliance-Focused Approach' },
];

function Stats() {
  return (
    <div className="container">
      <div className="stats">
        {STATS.map((stat) => (
          <div className="stats__card" key={stat.label}>
            <span className="stats__value">{stat.value}</span>
            <span className="stats__label">{stat.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Stats;
